<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="modal-wrapper fixed inset-0 bg-middle-dark/25 z-50 overflow-y-auto"
      data-test-id="component-majority-modal"
    >
      <div class="flex flex-col justify-center min-h-screen px-standart">
        <div v-click-away="backdropClick" class="modal-box relative bg-white w-full max-w-screen-md mx-auto my-standart" :class="boxClass">
          <button
            class="absolute top-0 right-0 py-2 px-micro hover:bg-middle-light focus:bg-middle-light focus:outline-none z-10"
            data-test-id="button-majority-modal-close"
            aria-label="Close icon"
            @click="isOpen = false"
          >
            <MajorityUiMajorityIcon icon="close" class="leading-none text-smallest align-top" />
          </button>
          <header
            v-if="title"
            class="h3 px-standart pt-micro"
            data-test-id="text-majority-modal-title"
            v-html="title"
          />
          <div
            :class="contentClass"
            data-test-id="block-majority-modal-content"
          >
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mixin as VueClickAway } from 'vue3-click-away'
export default {
  name: 'MajorityModal',
  mixins: [VueClickAway],
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: [Boolean, String],
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    boxClass: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: 'p-standart'
    }
  },
  setup (props) {
    useHead({
      bodyAttrs: {
        class: props.visible ? 'overflow-y-hidden' : ''
      }
    })
  },
  data () {
    return {
      isOpen: this.visible
    }
  },
  watch: {
    visible (val) {
      this.isOpen = val
    },
    isOpen (val) {

    }
  },
  methods: {
    show () {
      this.isOpen = true
    },
    hide () {
      this.isOpen = false
    },
    backdropClick () {
      if (this.backdrop) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s;
  .modal-box {
    @apply transition-all duration-300 ease-out;
  }
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  .modal-box {
    @apply opacity-0 transform translate-y-xxl;
  }
}

.fade-enter-to, .fade-leave /* .fade-leave-active below version 2.1.8 */ {
  .modal-box {
    @apply opacity-100 transform translate-y-0;
  }
}
</style>
